import { render, staticRenderFns } from "./MenuProductosExpandido.vue?vue&type=template&id=498a20d1&scoped=true&"
import script from "./MenuProductosExpandido.vue?vue&type=script&lang=js&"
export * from "./MenuProductosExpandido.vue?vue&type=script&lang=js&"
import style0 from "./MenuProductosExpandido.vue?vue&type=style&index=0&id=498a20d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498a20d1",
  null
  
)

/* custom blocks */
import block0 from "./MenuProductosExpandido.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports